import * as angular from 'angular';

import { ComponentDefinition, IApiInformation } from '../../../models';
import { IMsalAuthenticationService } from '@services/msalAuthentication.provider';
import { IEntraIdSignOnService } from '@services/general';
import { IStoreService } from '@services/store.service';
import { StoreElement } from '../../../stateManagement';

class EntraIdPageController implements angular.IComponentController {
    apiInformation: IApiInformation;
    isLoading: boolean;
    loadingMessage: string;
    private _unsubscribe: () => void;

    static $inject = ['$state', 'entraIdSignOnService', 'msalAuthenticationService', 'storeService'];
    constructor(
        private _$state: angular.ui.IStateService,
        private _entraIdSignOnService: IEntraIdSignOnService,
        private _msalAuthenticationService: IMsalAuthenticationService,
        private _storeService: IStoreService
    ) {}

    $onInit() {
        this.isLoading = true;
        this.loadingMessage = 'Acquiring token';
        this._msalAuthenticationService
            .acquireTokenSilent()
            .then((data) => {
                return this.login(data);
            })
            .catch((e) => this.reconnect());

        this._unsubscribe = this._storeService.register(
            (store) => {
                this.apiInformation = store.apiInformation.value;
            },
            [StoreElement.ApiInformation]
        );
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    reconnect() {
        return this._msalAuthenticationService.loginPopup(['user.read']).then((data) => this.login(data));
    }

    private login(data: { accessToken: string }) {
        this.loadingMessage = 'Logging in';
        return this._entraIdSignOnService
            .login(data.accessToken)
            .then(() => {
                // Same as for SSO
                let to;
                if (!this.apiInformation.isLicenseValid) {
                    to = { url: 'administration', params: {} };
                } else if (!to) {
                    to = { url: 'workspace', params: {} };
                }
                this._$state.go(to.url, to.params);
            })
            .catch((e) => {
                let message;
                try {
                    message = e.data.error_description;
                    console.error(message);
                } catch {
                    console.error(e);
                }
                this._$state.go('login', { message });
            });
    }
}

export const wtEntraIdPage: ComponentDefinition = {
    componentId: 'wtEntraIdPage',
    controller: EntraIdPageController,
    controllerAs: 'vm',
    template: require('./entraIdPage.component.html'),
    bindings: {}
};
